<template>
    <div class="course__edit_links">
        <template v-if="requestPending">
            <component-loading :size="'small'"></component-loading>
        </template>
        <template v-else>
            <course-edit-links-form
                :is-course="isRouteCourse"
                :is-catalog-item="isRouteCatalogItem"
            ></course-edit-links-form>
        </template>
    </div>
</template>

<script>
import { validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import CourseEditLinksForm from '@/components/ebs/courses/edit/CourseEditLinksForm'

export default {
  name: 'course-edit-links',
  components: {
    CourseEditLinksForm,
    ComponentLoading
  },
  data () {
    return {
      requestPending: false
    }
  },
  mixins: [validateBeforeRouteLeave, watchContentChangeEmit],
  computed: {
    loggedInUserWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    courseOwner () {
      return this.$store.getters.getEbsCourseOwner
    },
    //
    rootItemName () {
      return 'course'
    },
    //
    isAddMode () {
      return this.$route.name.includes('course-add')
    },
    isEditMode () {
      return this.$route.name.includes('course-edit')
    },
    isShowMode () {
      return this.$route.name.includes('course-show')
    },
    isRouteCourse () {
      return this.$route.name.includes('ebs-course-edit') || this.$route.name.includes('ebs-course-add')
    },
    isRouteCatalogItem () {
      return this.$route.name.includes('ebs-catalog-item-edit')
    },
    courseWorkspaceSettingsWorkspaces () {
      return this.$store.getters.getEbsCatalogItemWorkspacesSettings
    }
  },
  methods: {
    handleAddNewLink () {
      this.$refs.linkformnotify.openNotify()
    },
    getCourseWorkspaceSettings () {
      this.requestPending = true
      const catalogId = this.$route.params.catalogId
      this.$store.dispatch('ebsCatalogItemGetWorkspaceSettings', catalogId).finally(() => {
        this.requestPending = false
        this.$eventBus.$emit('stop-loading')
      })
    }
  },
  inject: ['$validator'],
  created () {
    if (!this.courseWorkspaceSettingsWorkspaces.length && this.isRouteCatalogItem) {
      this.getCourseWorkspaceSettings()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseaddeditlinks";
</style>
